export const jobsData = [
    {
        id: 1,
        title: "Senior Software Engineer",
        company: "TechCorp Solutions",
        location: "San Francisco, CA (Remote)",
        type: "Full-time",
        department: "Engineering",
        salary: "$120,000 - $150,000",
        experience: "5-7 years",
        posted: "2 days ago",
        applicants: 12,
        status: "Active",
        description: `We're looking for a Senior Software Engineer to join our growing team. You'll be working on cutting-edge technology solutions.

Key Responsibilities:
• Lead development of complex features
• Mentor junior developers
• Collaborate with product and design teams
• Participate in architectural decisions`,
        requirements: [
            "7+ years of software development experience",
            "Strong expertise in React, Node.js, and TypeScript",
            "Experience with cloud platforms (AWS preferred)",
            "Strong system design and architecture skills",
            "Excellent problem-solving abilities"
        ],
        benefits: [
            "Competitive salary + equity",
            "Health, dental, and vision insurance",
            "Unlimited PTO",
            "Remote work flexibility",
            "$5,000 annual learning budget"
        ],
        logo: "https://ui-avatars.com/api/?name=TC&background=6366f1&color=fff"
    },
    {
        id: 2,
        title: "Product Designer",
        company: "DesignHub",
        location: "New York, NY",
        type: "Full-time",
        department: "Design",
        salary: "$90,000 - $120,000",
        experience: "3-5 years",
        posted: "1 week ago",
        applicants: 18,
        status: "Active",
        description: `Join our design team to create beautiful and intuitive user experiences.

Key Responsibilities:
• Create user-centered designs
• Develop UI/UX solutions
• Work with development team
• Conduct user research`,
        requirements: [
            "5+ years of product design experience",
            "Strong portfolio showing UX process",
            "Expertise in Figma and design systems",
            "Experience with user research",
            "Strong communication skills"
        ],
        benefits: [
            "Competitive compensation",
            "Full benefits package",
            "Flexible hours",
            "Design conference budget",
            "Creative workspace"
        ],
        logo: "https://ui-avatars.com/api/?name=DH&background=8b5cf6&color=fff"
    },
    {
        id: 3,
        title: "Marketing Manager",
        company: "GrowthLabs",
        location: "Remote",
        type: "Full-time",
        department: "Marketing",
        salary: "$85,000 - $110,000",
        experience: "4-6 years",
        posted: "3 days ago",
        applicants: 24,
        status: "Active",
        description: `Lead our marketing efforts and drive growth across all channels.

Key Responsibilities:
• Develop marketing strategies
• Manage social media presence
• Create content strategy
• Analyze marketing metrics`,
        requirements: [
            "6+ years of marketing experience",
            "Experience with digital marketing",
            "Strong analytical skills",
            "Content strategy expertise",
            "Team management experience"
        ],
        benefits: [
            "Performance bonuses",
            "Health insurance",
            "Remote work",
            "Professional development",
            "Team retreats"
        ],
        logo: "https://ui-avatars.com/api/?name=GL&background=10b981&color=fff"
    }
];

export const companiesData = [
    {
        id: 1,
        name: "TechCorp Solutions",
        industry: "Technology",
        size: "500-1000",
        location: "San Francisco, CA",
        founded: 2015,
        website: "www.techcorp.com",
        about: "Leading technology solutions provider",
        logo: "https://ui-avatars.com/api/?name=TC&background=6366f1&color=fff"
    },
    {
        id: 2,
        name: "DesignHub",
        industry: "Design Services",
        size: "100-500",
        location: "New York, NY",
        founded: 2018,
        website: "www.designhub.com",
        about: "Creative design agency",
        logo: "https://ui-avatars.com/api/?name=DH&background=8b5cf6&color=fff"
    }
];

export const jobBoardsData = [
    {
        id: 1,
        name: "LinkedIn",
        logo: "/images/linkedin.png",
        status: "connected",
        description: "Professional networking platform",
        activeJobs: 15
    },
    {
        id: 2,
        name: "Indeed",
        logo: "/images/indeed.png",
        status: "disconnected",
        description: "World's #1 job site",
        activeJobs: 0
    },
    {
        id: 3,
        name: "Glassdoor",
        logo: "/images/glassdoor.png",
        status: "connected",
        description: "Company reviews and jobs",
        activeJobs: 8
    }
];

export const candidatesData = [
    {
        id: 1,
        name: "John Smith",
        email: "john.smith@email.com",
        role: "Software Engineer",
        experience: "5 years",
        status: "Interviewing",
        appliedFor: "Senior Software Engineer",
        appliedDate: "2024-01-15"
    },
    {
        id: 2,
        name: "Sarah Johnson",
        email: "sarah.j@email.com",
        role: "Product Designer",
        experience: "3 years",
        status: "Shortlisted",
        appliedFor: "Product Designer",
        appliedDate: "2024-01-18"
    }
]; 